export const buildColumn = (title: string, key: string, options?: Record<string, unknown>) => ({
  title,
  key,
  dataIndex: key,
  ...options,
});
